import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_menu_item_navigation = _resolveComponent("menu-item-navigation")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_menu_item_navigation, { url: "/request-partner" }, {
      default: _withCtx(() => [
        _createTextVNode("Send a request")
      ]),
      _: 1
    }),
    _createVNode(_component_menu_item_navigation, {
      "is-active": _ctx.isReviewRequestActive,
      url: "/review-request"
    }, {
      default: _withCtx(() => [
        _createTextVNode("Review completed requests")
      ]),
      _: 1
    }, 8, ["is-active"]),
    _createVNode(_component_menu_item_navigation, { url: "/request-sent" }, {
      default: _withCtx(() => [
        _createTextVNode("Requests sent")
      ]),
      _: 1
    }),
    _createVNode(_component_menu_item_navigation, { url: "/request-approved" }, {
      default: _withCtx(() => [
        _createTextVNode("Approved requests")
      ]),
      _: 1
    })
  ]))
}